export const routerPath = {
  root: '/benefits',
  link: '/settings/benefits',
};

export const getColumns = ({ editItem, deleteItem }) => [
  { id: 'name', label: 'Name', align: 'center' },
  { id: 'level', label: 'Level', align: 'center' },
  { id: 'headerText', label: 'Header Text', align: 'center' },
  {
    id: 'active',
    label: 'Active',
    customValue: (item) => (item.active ? 'Active' : 'Inactive'),
    align: 'center',
  },
  {
    id: 'more-menu',
    type: 'menu',
    items: [
      {
        id: 'delete',
        name: 'Delete',
        action: deleteItem,
        icon: 'eva:trash-2-outline',
        sx: { color: 'error.main' },
      },
      { id: 'edit', name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
    ],
    disableSort: true,
  },
];

export const getFilters = ({ level, searchByName, status, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by name',
    action: searchByName.change,
  },
  {
    id: 'level',
    type: 'select',
    label: 'Level',
    value: level.value,
    action: level.change,
    items: options?.levels?.length ? [...options.levels] : [''],
  },
  {
    id: 'Active',
    type: 'select',
    label: 'Active',
    value: status.value,
    action: status.change,
    items: ['all', 'active', 'inactive'],
  },
];
